<template>
    <div v-show="popup_show" id="download-popup" @touchmove.prevent>
        <div class="popup-body">
            <img class="popup-body-head" src="../assets/download/start_icon.png" alt="">
            <div class="popup-body-content">
                <p class="popup-body-text">{{ popup_text }}</p>
                <span v-show="popup_btn" class="popup-body-go" @click="goDownload">Tekan</span>
            </div>

            <img @click="handleClose" class="popup-body-close" src="../assets/download/close_icon.png">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            popup_show: false,
            popup_text: 'lihat 200+ data lebih rinci，silakan download app',
            popup_btn: true,// 是否现在下载按钮
            now_local_date: new Date().toLocaleDateString()
        }
    },

    mounted() {
        if (!window.sessionStorage) {
            window.sessionStorage = {
                getItem: function () { },
                setItem: function () { }
            }
        }
        if (!window.localStorage) {
            window.localStorage = {
                getItem: function () { },
                setItem: function () { }
            }
        }
    },

    methods: {
        // 关闭按钮方法
        handleClose() {
            this.popup_show = false
        },

        // 下载按钮事件
        goDownload() {
            sessionStorage.setItem('loop_run', 'true')
            this.popup_show = false
            var browers = {}
            var ua = navigator.userAgent.toLowerCase()
            browers.Android = ua.match(/android/)
            browers.iOS = ua.match(/ipad|iphone|ios/)
            if (browers.Android) {
                location.href = '/download'
            } else if (browers.iOS) {
                let utilObj = require('@/util/util.js')
                utilObj.jumpUrl()
            }
        },
    }
}
</script>

<style lang="less" scoped>
    #download-popup {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 10000;
        background-color: rgba(0, 0, 0, .6);
        .popup-body {
            position: relative;
            width: 75%;
            height: 200px;
            margin: 0 auto;
            margin-top: 10rem;
            background-size: 100%;
        }
        .popup-body-head {
            display: block;
            width: 140px;
            margin: 0 auto;
        }
        .popup-body-content {
            margin-top: -45px;
            padding-bottom: 10px;
            border-radius: 5px;
            background: #fff;
        }
        .popup-body-close {
            position: absolute;
            top: -.5rem;
            right: -.5rem;
            width: 2.6rem;
            height: 2.6rem;
            line-height: 1.6rem;
        }
        .popup-body-go {
            display: block;
            width: 90%;
            height: 2.6rem;
            margin: 0 auto;
            margin-top: 5px;
            color: #fff;
            text-align: center;
            line-height: 2.6rem;
            border-radius: 5px;
            font-weight: 800;
            background-color: #25c023;
        }
        .popup-body-text {
            padding: 0 10px;
            padding-top: 50px;
            margin-bottom: 15px;
            text-align: center;
            font-size: 1rem;
        }
    }
</style>



// WEBPACK FOOTER //
// downloadPopup.vue?25632421